import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'flow-kpi-box-single',
  templateUrl: './kpi-box-single.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiBoxSingleComponent implements OnInit {
  @Input() groupTitle: any;
  @Input() title: any;
  @Input() subTitle: any;
  @Input() value: string | number = 0;
  @Input() percentageDifference: string | number;
  @Input() trend: boolean;
  @Input() description: string = '';
  @Input() highlight: boolean;

  highlightBackgroundClass: string = '';
  highlightTextClass: string = '';

  ngOnInit() {
    this.setStyle();
  }

  setStyle() {
    const bgColor = {
      highlight: 'bg-chathams-blue-100 border-chathams-blue-400',
      default: 'bg-white border-neutral-200',
    };

    const txtColor = {
      highlight: 'text-brand-chathams-blue',
      default: 'text-brand-bright-orange',
    }

    this.highlightBackgroundClass = bgColor[this.highlight ? 'highlight': 'default'];
    this.highlightTextClass = txtColor[this.highlight ? 'highlight': 'default'];
  }
}
